// ImageCarousel.tsx
import React, { useState, useEffect, ReactNode } from "react";
import "./index.css";
import { Typography } from "@mui/material";

interface ImageCarouselProps {
  children: ReactNode[];
  interval?: number; // Optional interval prop for autoplay
  content: { description: string; header: string }[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  children,
  interval = 4000,
  content,
}) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % children.length);
  };

  useEffect(() => {
    const autoplay = setInterval(() => {
      if (!isHovered) {
        nextImage();
      }
    }, interval);

    return () => clearInterval(autoplay); // Cleanup on unmount
  }, [isHovered, interval]);

  const goToImage = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <div
      className="carousel"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        className="carousel-content"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {children.map((child, index) => (
          <div className="carousel-item" key={index}>
            <div className="carousel_overlay"></div>
            {child}
          </div>
        ))}
      </div>
      {content[currentIndex] && (
        <div className="banner_content">
          <Typography variant="h2" className="banner_content_header">
            {content[currentIndex].header}
          </Typography>
          <Typography className="banner_content_sub-header">
            {content[currentIndex].description}
          </Typography>
        </div>
      )}
      <div className="dots">
        {children.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => goToImage(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
